import {selfInstallKitWidget} from '../SelfInstallKitStore';
import {proxy, subscribe} from 'valtio';
import {ShippingAddress} from '@/lib/TypesOpenApi';

export interface ShippingAddressState {
  shippingAddressInfo?: ShippingAddress;
}

export const shippingAddress = proxy<ShippingAddressState>({
  shippingAddressInfo: undefined,
});

subscribe(selfInstallKitWidget, () => {
  if (shippingAddress.shippingAddressInfo) {
    return;
  }

  const addressInfo = selfInstallKitWidget.shippingWidget?.addressInfo;

  if (addressInfo) {
    shippingAddress.shippingAddressInfo = {
      recipientName: undefined,
      phoneNumber: undefined,
      physicalAddress: {
        streetAddress: addressInfo.streetAddress,
        unitNumber: addressInfo.unitNumber,
        city: addressInfo.city,
        zipcode: addressInfo.zipcode,
        state: addressInfo.state,
      },
    };
  }
});

export const resetShippingAddressState = () => {
  shippingAddress.shippingAddressInfo = undefined;
};

export function setShippingAddress(addressInfo: ShippingAddress) {
  shippingAddress.shippingAddressInfo = addressInfo;
}
